// src/js/components/blogs-tag-component.js
var BlogTagComponent = class extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.select = this.querySelector("select");
    if (this.select) {
      this.select.addEventListener("change", this.navigateToTag.bind(this));
    }
  }
  navigateToTag() {
    const selectedValue = this.select.value;
    if (selectedValue) {
      window.location.href = selectedValue;
    }
  }
};
customElements.define("blogs-tag-component", BlogTagComponent);
